import BHBecomeMember from "./BHBecomeMember";

export default BHBecomeMember;
